import { createContext, useContext } from "react";

const DEFAULT_METAMASK_WALLET_CONTEXT = {
    currentVerifiedPolygonPubKey: "",
    isMetamaskInstalled: false,
    retrievingAccount: false,
    retrievingChainId: false,
    doAuth: async () => {},
    doMetamaskOnboarding: () => {},
};
export const MetamaskWalletContext = createContext(
    DEFAULT_METAMASK_WALLET_CONTEXT
);
export function useMetamaskWallet() {
    return useContext(MetamaskWalletContext);
}
